import { FormattedMessage, useIntl } from 'react-intl'
import { useRecoilCallback, useRecoilValue, useResetRecoilState } from 'recoil'

import {
  Button,
  Link,
  Modal,
  ModalBody,
  ModalFoot,
  ModalHead,
  Text,
  toastShow,
  TOAST_VARIANT_ERROR,
  TOAST_VARIANT_SUCCESS,
  TOAST_VARIANT_WARNING
} from 'mailup-web-components'

import {
  ENTITY_TYPE_ABTEST,
  ENTITY_TYPE_ACTIVITY_FILTER,
  ENTITY_TYPE_AGGREGATE_REPORT,
  ENTITY_TYPE_ANAGRAPHIC_FILTER,
  ENTITY_TYPE_AUTOMATION_WORKFLOW,
  ENTITY_TYPE_CONFIRMATION,
  ENTITY_TYPE_DYNAMIC_CONTENT,
  ENTITY_TYPE_LANDING_PAGE,
  ENTITY_TYPE_POPUP_FORM,
  ENTITY_TYPE_SUBCRIPTION_FORM,
  ENTITY_TYPE_TRIGGER,
  ENTITY_TYPE_WELCOME
} from 'Constants/'
import {
  MESSAGE_LIST_TYPE_ARCHIVED,
  MESSAGE_STR_TYPE_WELCOME
} from 'Constants/index'
import { notifyParent } from 'Helpers/notifyParent'
import { useHistory } from 'react-router-dom'
import {
  archiveMessagesCallback,
  deleteMessagesCallback,
  searchMessagesCallback
} from '../recoil/callbacks/callbacks'
import { modalDeleteState } from '../recoil/state/page'
import { resultsState } from '../recoil/state/results'

const escapeStrong = t => <strong>{t}</strong>

const redirectToTriggers = id => {
  notifyParent('redirectMainFrame', [`App.aspx#/triggersDetail/${id}`])
}

const redirectToSubscriptionForm = id => {
  notifyParent('redirectMainFrame', [
    `databasebuilding_app_redirector.aspx?r=${encodeURIComponent(
      `databasebuilding/engagement/${id}/edit`
    )}`
  ])
}

const redirectToLandingPage = id => {
  notifyParent('redirectMainFrame', [
    `databasebuilding_app_redirector.aspx?r=${encodeURIComponent(
      `/databasebuilding/landingpage/${id}/settings`
    )}`
  ])
}

const redirectToAutomationWorkflow = id => {
  notifyParent('redirectMainFrame', [
    `automation_app_redirector.aspx?r=${encodeURIComponent(
      `/automation/workflow/${id}/edit`
    )}`
  ])
}

const redirectToDynamicContents = id => {
  notifyParent('redirectMainFrame', [
    `GestoreContenutiEsterni.aspx?idContenuto=${id}`
  ])
}

const redirectToProfileFilters = id => {
  notifyParent('redirectMainFrame', [
    `filters_app_redirector.aspx?r=edit_profile:${id}`
  ])
}

const redirectToActivityFilters = id => {
  notifyParent('redirectMainFrame', [
    `filters_app_redirector.aspx?r=edit_activity:${id}`
  ])
}

const redirectToAggregateReport = id => {
  notifyParent('redirectMainFrame', [
    `statistics_app_redirector.aspx?r=/stats/insight/aggregate/settings/${id}`
  ])
}

const ModalDelete = () => {
  const intl = useIntl()
  const history = useHistory()

  const { show, items, allMessageArchived } = useRecoilValue(modalDeleteState)
  const resetModal = useResetRecoilState(modalDeleteState)
  const deleteMessages = useRecoilCallback(deleteMessagesCallback, [])
  const archiveMessages = useRecoilCallback(archiveMessagesCallback, [])
  const fetchResults = useRecoilCallback(searchMessagesCallback, [])
  const results = useRecoilValue(resultsState)

  const handleConfirm = () => {
    resetModal()
    deleteMessages(items, onDeleteSuccess)
  }

  const handleArchive = () => {
    resetModal()
    archiveMessages(items, onArchiveMessagesSuccess)
  }

  const redirectToABTest = id => {
    history.push(`/messages/email/abtestmanage/${id}`)
  }

  const redirectToPopupForm = id => {
    notifyParent('redirectMainFrame', [
      `databasebuilding_app_redirector.aspx?r=${encodeURIComponent(
        `/databasebuilding/multichannel/edit/${id}`
      )}`
    ])
  }

  const renderNotDeletedMessage = msg => {
    const related = msg.onSent ? undefined : msg.entities.pop()

    return (
      <>
        {msg.onSent && (
          <FormattedMessage
            id='Load.ToastDeleteEmailMessage.IsOnSent'
            values={{
              strong: escapeStrong,
              MGSNAME: `${msg.idMessage} - ${msg.subject}`
            }}
          />
        )}
        {!msg.onSent && (
          <span>
            <FormattedMessage
              id='Load.ToastDeleteEmailMessage.Intro'
              values={{
                strong: escapeStrong,
                MGSNAME: `${msg.idMessage} - ${msg.subject}`
              }}
            />{' '}
            {related.Type === ENTITY_TYPE_TRIGGER && (
              <FormattedMessage
                id='Load.ToastDeleteEmailMessage.UsedForTask'
                values={{
                  strong: escapeStrong,
                  ID: related.Id,
                  ENTITYNAME: (
                    <a href='#' onClick={() => redirectToTriggers(related.Id)}>
                      {related.Name}
                    </a>
                  )
                }}
              />
            )}
            {related.Type === ENTITY_TYPE_DYNAMIC_CONTENT && (
              <FormattedMessage
                id='Load.ToastDeleteEmailMessage.UsedForDynamicContent'
                values={{
                  strong: escapeStrong,
                  ID: related.Id,
                  ENTITYNAME: (
                    <a
                      href='#'
                      onClick={() => redirectToDynamicContents(related.Id)}
                    >
                      {related.Name}
                    </a>
                  )
                }}
              />
            )}
            {related.Type === ENTITY_TYPE_ANAGRAPHIC_FILTER && (
              <FormattedMessage
                id='Load.ToastDeleteEmailMessage.UsedForProfileFilter'
                values={{
                  strong: escapeStrong,
                  ID: related.Id,
                  ENTITYNAME: (
                    <a
                      href='#'
                      onClick={() => redirectToProfileFilters(related.Id)}
                    >
                      {related.Name}
                    </a>
                  )
                }}
              />
            )}
            {related.Type === ENTITY_TYPE_ACTIVITY_FILTER && (
              <FormattedMessage
                id='Load.ToastDeleteEmailMessage.UsedForActivityFilter'
                values={{
                  strong: escapeStrong,
                  ID: related.Id,
                  ENTITYNAME: (
                    <a
                      href='#'
                      onClick={() => redirectToActivityFilters(related.Id)}
                    >
                      {related.Name}
                    </a>
                  )
                }}
              />
            )}
            {related.Type === ENTITY_TYPE_AUTOMATION_WORKFLOW && (
              <FormattedMessage
                id='Load.ToastDeleteEmailMessage.UsedForWorkflow'
                values={{
                  strong: escapeStrong,
                  ID: related.Id,
                  ENTITYNAME: (
                    <a
                      href='#'
                      onClick={() => redirectToAutomationWorkflow(related.Id)}
                    >
                      {related.Name}
                    </a>
                  )
                }}
              />
            )}
            {related.Type === ENTITY_TYPE_ABTEST && (
              <FormattedMessage
                id='Load.ToastDeleteEmailMessage.UsedForAbTest'
                values={{
                  strong: escapeStrong,
                  ID: related.Id,
                  ENTITYNAME: (
                    <a href='#' onClick={() => redirectToABTest(related.Id)}>
                      {related.Name}
                    </a>
                  )
                }}
              />
            )}
            {related.Type === ENTITY_TYPE_WELCOME && (
              <FormattedMessage id='Load.ToastDeleteEmailMessage.UsedForWelcomeEmail' />
            )}
            {related.Type === ENTITY_TYPE_CONFIRMATION && (
              <FormattedMessage id='Load.ToastDeleteEmailMessage.UsedForConfirmationRequestEmail' />
            )}
            {related.Type === ENTITY_TYPE_AGGREGATE_REPORT && (
              <FormattedMessage
                id='Load.ToastDeleteEmailMessage.UsedForAggregateReport'
                values={{
                  strong: escapeStrong,
                  ID: related.Id,
                  ENTITYNAME: (
                    <a
                      href='#'
                      onClick={() => redirectToAggregateReport(related.Id)}
                    >
                      {related.Name}
                    </a>
                  )
                }}
              />
            )}
            {related.Type === ENTITY_TYPE_SUBCRIPTION_FORM && (
              <FormattedMessage
                id='Load.ToastDeleteEmailMessage.UsedForSubscriptionForm'
                values={{
                  strong: chunks => <strong>{chunks}</strong>,

                  ID: related.Id,

                  ENTITYNAME: (
                    <a
                      href='#'
                      onClick={() => redirectToSubscriptionForm(related.Id)}
                    >
                      {related.Name}
                    </a>
                  )
                }}
              />
            )}
            {related.Type === ENTITY_TYPE_LANDING_PAGE && (
              <FormattedMessage
                id='Load.ToastDeleteEmailMessage.UsedForLandingPage'
                values={{
                  strong: chunks => <strong>{chunks}</strong>,
                  ID: related.Id,
                  ENTITYNAME: (
                    <a onClick={() => redirectToLandingPage(related.Id)}>
                      {related.Name}
                    </a>
                  )
                }}
              />
            )}
            {related.Type === ENTITY_TYPE_POPUP_FORM && (
              <FormattedMessage
                id='Load.ToastDeleteEmailMessage.UsedForPopupForm'
                values={{
                  strong: chunks => <strong>{chunks}</strong>,
                  ID: related.Id,
                  ENTITYNAME: (
                    <a onClick={() => redirectToPopupForm(related.Id)}>
                      {related.Name}
                    </a>
                  )
                }}
              />
            )}
          </span>
        )}
      </>
    )
  }

  const onArchiveMessagesSuccess = (toArchive, notToArchive) => {
    if (notToArchive.length === 1) {
      const warningMessage =
        notToArchive[0].MessageType === MESSAGE_STR_TYPE_WELCOME ? (
          <FormattedMessage
            id='Load.EmailMessageList.ArchiveMessageErrorWelcome'
            values={{
              strong: chunks => <strong>{chunks}</strong>,
              MGSNAME: notToArchive[0].Subject
            }}
          />
        ) : (
          <FormattedMessage
            id='Load.EmailMessageList.ArchiveMessageErrorConfirm'
            values={{
              strong: chunks => <strong>{chunks}</strong>,
              MGSNAME: notToArchive[0].Subject
            }}
          />
        )

      toastShow(
        warningMessage,
        TOAST_VARIANT_WARNING,
        'ArchiveMessageError',
        true
      )
    }
    if (notToArchive.length === 2) {
      const warningMessage = (
        <FormattedMessage
          id='Load.EmailMessageList.ArchiveMessageErrorMultiple'
          values={{
            strong: chunks => <strong>{chunks}</strong>,
            MESSAGECOUNT: notToArchive.length
          }}
        />
      )
      toastShow(
        warningMessage,
        TOAST_VARIANT_WARNING,
        'ArchiveMessageError',
        true
      )
    }

    if (toArchive.length) {
      toastShow(
        intl.formatMessage({ id: 'Load.EmailMessageList.ArchiveSuccess' }),
        TOAST_VARIANT_SUCCESS,
        'ArchiveSuccess',
        true
      )
      fetchResults()
    }
  }

  const onDeleteSuccess = (notDeleted, deleted) => {
    if (deleted.length) {
      fetchResults()

      const msg =
        deleted.length === 1 ? (
          <FormattedMessage
            id='Load.ActiveRecipientSummary.SuccessDeleteMessageSingle'
            values={{
              strong: escapeStrong,
              MGSNAME: `${deleted[0].idMessage} - ${deleted[0].subject}`
            }}
          />
        ) : (
          <FormattedMessage
            id='Load.ActiveRecipientSummary.SuccessDeleteMessageMultiple'
            values={{ strong: escapeStrong, MESSAGECOUNT: deleted.length }}
          />
        )
      const msgSource =
        deleted.length === 1 ? 'deleteSingleSuccess' : 'deleteMultipleSuccess'

      toastShow(msg, TOAST_VARIANT_SUCCESS, msgSource, true)
    }

    if (notDeleted.length) {
      const msg =
        notDeleted.length === 1 ? (
          renderNotDeletedMessage(notDeleted[0])
        ) : (
          <FormattedMessage
            id='Load.ToastDeleteEmailMessage.UsedMoreFeatures'
            values={{ strong: escapeStrong, MESSAGECOUNT: notDeleted.length }}
          />
        )

      const msgSource =
        deleted.length === 1 ? 'deletSingleError' : 'deleteMultipleError'

      toastShow(msg, TOAST_VARIANT_ERROR, msgSource, true)
    }
  }

  return (
    <Modal show={show} onClose={resetModal}>
      <ModalHead
        title={
          items.length > 1
            ? intl.formatMessage(
                { id: 'Load.EmailMessageList.MessageConfirmDeleteTitle' },
                { COUNT: items.length }
              )
            : results &&
              items.length > 0 &&
              results.items.filter(f => f.Id === items[0]).length > 0
            ? intl.formatMessage(
                { id: 'Load.EmailMessageList.TitleConfirmDelete' },
                {
                  name: results.items.filter(f => f.Id === items[0])[0].Subject
                }
              )
            : intl.formatMessage({
                id: 'Load.EmailMessageList.OneMessageConfirmDeleteTitle'
              })
        }
      />
      <ModalBody>
        <Text>
          {!allMessageArchived &&
            results.searchParams.type !== MESSAGE_LIST_TYPE_ARCHIVED &&
            (items.length > 1
              ? intl.formatMessage(
                  {
                    id: 'Load.EmailMessageList.TitleConfirmDeleteArchivePlural'
                  },
                  {
                    strong: chunks => <strong>{chunks}</strong>
                  }
                )
              : intl.formatMessage(
                  {
                    id: 'Load.EmailMessageList.TitleConfirmDeleteArchive'
                  },
                  {
                    strong: chunks => <strong>{chunks}</strong>
                  }
                ))}
          {(allMessageArchived ||
            results.searchParams.type === MESSAGE_LIST_TYPE_ARCHIVED) &&
            (items.length > 1
              ? intl.formatMessage(
                  {
                    id:
                      'Load.EmailMessageList.MoreMessageConfirmDeleteParagraph'
                  },
                  {
                    strong: chunks => <strong>{chunks}</strong>
                  }
                )
              : intl.formatMessage(
                  { id: 'Load.EmailMessageList.MessageConfirmDelete' },
                  {
                    strong: chunks => <strong>{chunks}</strong>
                  }
                ))}
        </Text>
      </ModalBody>
      <ModalFoot>
        <Link
          className='textlink-extra-light p-right-thin'
          onClick={resetModal}
          data-mu-test={
            items.length > 1 ? 'link-cancel-multiple' : 'link-cancel'
          }
        >
          {intl.formatMessage({
            id: 'Load.ModalConfermeDelete.Cancel'
          })}
        </Link>
        <Button
          kind={'danger'}
          onClick={handleConfirm}
          data-mu-test={
            items.length > 1 ? 'button-confirm-multiple' : 'button-confirm'
          }
        >
          {intl.formatMessage({ id: 'Load.MailupCommon.Delete' })}
        </Button>
        {!allMessageArchived &&
          results.searchParams.type !== MESSAGE_LIST_TYPE_ARCHIVED && (
            <Button
              kind={'primary'}
              onClick={handleArchive}
              data-mu-test={
                items.length > 1 ? 'button-archive-multiple' : 'button-archive'
              }
            >
              {intl.formatMessage({
                id: 'Load.EmailMessageList.ActionFooterArchive'
              })}
            </Button>
          )}
      </ModalFoot>
    </Modal>
  )
}

export default ModalDelete
